import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { register } from 'swiper/element/bundle';

let hasRegisteredSwiperElements = false;

export const ensureSwiperElementsRegistered = () => {
  if (hasRegisteredSwiperElements || customElements.get('swiper-container')) {
    hasRegisteredSwiperElements = true;
    return Promise.resolve();
  }

  register();

  if (!customElements.get('swiper-container')) {
    return Promise.reject(
      new Error('Houve um erro ao registrar os elementos do Swiper.'),
    );
  }

  hasRegisteredSwiperElements = true;
  return Promise.resolve();
};
